<template>
  <div id="feedback-step">
    <div class="feedback-step-container">
<!--      handling different question types     -->
      <OptionsSlider
        v-if="question.type === 'slider'"
        :question="question"
        :answer="answer"
        :setAnswer="setAnswer"
      ></OptionsSlider>
      
      <FeedbackTextArea
        v-if="question.type === 'multiline-text-input'"
        :question="question"
        :answer="answer"
        :setAnswer="setAnswer"
      ></FeedbackTextArea>
    
    </div>
  </div>
</template>

<script>
import NavigationCard from "@/components/Home/New/NavigationCard.vue";
import OptionsSlider from "@/components/Home/New/OptionsSlider.vue";
import FeedbackTextArea from "@/components/Home/New/FeedbackTextArea.vue";

export default {
  components: {
    FeedbackTextArea,
    OptionsSlider,
    NavigationCard
  },
  name: "FeedbackStep",
  props: ["answer", "setAnswer", "question"],
  data() {
    return {
      question: this.questions[0]
    };
  },
};
</script>
<style lang="less">

#feedback-step {
  
  .feedback-step-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
  }
}
</style>
